import { SearchPageFilterState } from 'src/hooks/useSearchPage';

import AlphaButtons, { AlphaOption } from 'components/BaseHelpers/AlphaButtons/AlphaButtons';

export type PeopleAlphaButtonsProps = {
  letterFilter: SearchPageFilterState;
  /**
   * The `lastnameletter` slice of the criteria-level facet state (slim `value -> count`
   * shape, lowercased values. `undefined`
   * means facets are unavailable → all letters enabled (fail-open).
   */
  facetState?: Record<string, number>;
  className?: string;
};

const PeopleAlphaButtons = (props: PeopleAlphaButtonsProps): JSX.Element => {
  const { letterFilter, facetState, className } = props;

  const alphaOptions = ((): Array<AlphaOption> => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    return letters.map((letter) => {
      const isSelected = letterFilter.selectedValues.includes(letter.toLowerCase());

      return {
        name: letter.toLowerCase(),
        label: letter,
        // Compare by the lowercased facet value (option.name), not the uppercase label. The
        // selected letter always stays enabled (toggle-off); all letters stay enabled while
        // facets are unavailable (fail-open).
        disabled:
          !isSelected && facetState !== undefined && (facetState[letter.toLowerCase()] ?? 0) === 0,
        active: isSelected,
      };
    });
  })();

  const alphaButtonsOnClick = (option: AlphaOption) => {
    const isSelected = letterFilter.selectedValues.includes(option.name);

    if (isSelected) {
      letterFilter.setSelectedValues(
        letterFilter.selectedValues.filter((value) => value !== option.name)
      );
      return;
    }
    letterFilter.setSelectedValues([option.name]);
  };

  return (
    <AlphaButtons options={alphaOptions} onClick={alphaButtonsOnClick} className={className} />
  );
};

export default PeopleAlphaButtons;
